module.exports = __webpack_public_path__ + "img/mail.98d8a713.svg";